import { render } from "./Loading.vue?vue&type=template&id=6b6cef84&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=6b6cef84&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6cef84"]])

export default __exports__